import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { NavElement } from "type/navigation/main_navigation.type";

type NavItemSmallScreenProps = {
  navItem: NavElement;
  clickHandle?: Function;
};

const NavItemSmallScreen = ({
  navItem,
  clickHandle,
}: NavItemSmallScreenProps) => {
  const navClickHandle = () => {
    if (clickHandle) {
      clickHandle();
    }
  };

  return (
    <DivMenuItem>
      <NavLink to={navItem.path} onClick={navClickHandle}>
        {navItem.title}
      </NavLink>
    </DivMenuItem>
  );
};

const DivMenuItem = styled.div`
  text-align: right;
  margin-top: 0.5rem;
  a {
    color: ${(props) => props.theme.color.link};
    font-size: ${(props) => props.theme.font.size.normal};
    font-weight: ${(props) => props.theme.font.weight.bold};
    font-family: ${(props) => props.theme.font.family.link};
    text-decoration: none;
    text-transform: uppercase;
  }
`;

export default NavItemSmallScreen;
